import { render, staticRenderFns } from "./FakeLoginToCO.vue?vue&type=template&id=63605086&scoped=true&"
import script from "./FakeLoginToCO.vue?vue&type=script&lang=js&"
export * from "./FakeLoginToCO.vue?vue&type=script&lang=js&"
import style0 from "./FakeLoginToCO.vue?vue&type=style&index=0&id=63605086&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63605086",
  null
  
)

export default component.exports